import React, { useEffect, useState } from "react";
import Myheader from "./Myheader";
import {
    Card,
    CardContent,
    CircularProgress,
    Grid,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails
} from "@mui/material";

import axios from "axios";
import { Apiurl } from "../api_urls";
import Gmodal from "./Gmodal";
import Driverheader from "../DriverComponent/Driverheader";

function Faq({ usertype }) {

    const [suppordata, setsupportdata] = useState(null);
    const [isloading, setisloading] = useState(false);

    const [mymodaldata, setmymodaldata] = useState({
        modalshow: false,
        modaltype: "success",
        modalmessage: ""
    });

    function closemodal(e) {
        setmymodaldata({
            modalshow: e,
            modalmessage: "",
            modaltype: ""
        });
    }

    const getsupportdetails = async () => {

        setisloading(true);

        const token = localStorage.getItem("access_token");
        const role = localStorage.getItem("role");

        try {

            const response = await axios.get(Apiurl.GET_FAQ, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Role: role
                }
            });

            if (response.status === 200 && response.data.status === 200) {

                setsupportdata(response.data.data);

            } else {

                setmymodaldata({
                    modalshow: true,
                    modaltype: "error",
                    modalmessage: "Server Error"
                });

            }

        } catch (error) {

            setmymodaldata({
                modalshow: true,
                modaltype: "error",
                modalmessage: `Server Error: ${error.message}`
            });

        } finally {

            setisloading(false);

        }
    };

    useEffect(() => {
        getsupportdetails();
    }, []);

    return (
        <>
            {usertype === "driver" ? <Driverheader /> : <Myheader />}

            <Grid container spacing={3} sx={{ p: 2 }}>

                <Grid item md={12} sm={12} xs={12}>

                    <Card
                        sx={{
                            boxShadow: "1px 1px 7px 1px grey"
                        }}
                    >

                        <CardContent>

                            <Typography
                                variant="h4"
                                sx={{ mb: 2 }}
                            >
                                Frequently Asked Questions
                            </Typography>

                            {isloading ? (

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        padding: "30px"
                                    }}
                                >
                                    <CircularProgress />
                                </div>

                            ) : suppordata && suppordata.length > 0 ? (

                                suppordata.map((item, index) => (

                                    <Accordion key={index}>

                                        <AccordionSummary
                                            aria-controls={`panel${index}-content`}
                                            id={`panel${index}-header`}
                                        >

                                            <Typography
                                                sx={{
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                {item?.question}
                                            </Typography>

                                        </AccordionSummary>

                                        <AccordionDetails>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: item?.answer || ""
                                                }}
                                            />

                                        </AccordionDetails>

                                    </Accordion>

                                ))

                            ) : (

                                <Typography>
                                    No FAQs available.
                                </Typography>

                            )}

                        </CardContent>

                    </Card>

                </Grid>

            </Grid>

            {mymodaldata.modalshow && (
                <Gmodal
                    data={mymodaldata}
                    closemodal={closemodal}
                />
            )}

        </>
    );
}

export default Faq;